import { IconLock } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface LockedProps {
  show?: boolean;
  showInfo?: boolean;
};

export function Locked({ show, showInfo }: LockedProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Planets' });

  if (!show) return null;

  return (
    <>
      <div className="absolute inset-0 grid-overlay" />
      <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/85 text-gray-500">
        <div className="flex items-center">
          <IconLock size={14} />
          <p className="text-sm ml-1">{t('locked')}</p>
        </div>

        {showInfo && (
          <p className="text-sm mt-1">
            {t('unlockPrevious')}
          </p>
        )}
      </div>
    </>
  );
}